const center = { lat: 49.820355047291855, lng: 18.685836309091574 };

function MapComponent() {
    return (
        <div className="map-container">
            <iframe
                title="Biuro Rachunkowe Saldo"
                src={`https://maps.google.com/maps?q=${center.lat},${center.lng}&z=16&output=embed`}
                style={{ width: '99.5vw', height: '700px', margin: 0, border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
            />
        </div>
    );
}

export default MapComponent;
